import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    reasonsForDelay: {
        id: 'iaso.polio.label.reasonsForDelay',
        defaultMessage: 'Reasons for delay',
    },
    create: {
        id: 'iaso.polio.label.create',
        defaultMessage: 'Create',
    },
    createdAt: {
        id: 'iaso.forms.created_at',
        defaultMessage: 'Created',
    },
    updatedAt: {
        id: 'iaso.forms.updated_at',
        defaultMessage: 'Updated',
    },
    timesSelected: {
        id: 'iaso.polio.label.timesSelected',
        defaultMessage: 'Times selected',
    },
    name_fr: {
        id: 'iaso.polio.label.name_fr',
        defaultMessage: 'French text',
    },
    name_en: {
        id: 'iaso.polio.label.name_en',
        defaultMessage: 'English text',
    },
    keyName: {
        id: 'iaso.polio.label.keyName',
        defaultMessage: 'Key',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
});

export default MESSAGES;
